export default {
	title: "Mensagens",
	newMessage: "Nova Mensagem",
	resolve: "Resolver",
	resolved: "Resolvida",
	active: "Ativa",
	noMessages: "Nenhuma mensagem",
	type: {
		ALERT: "Alerta",
		PENDENCY: "Pendência",
		NOTE: "Observação",
		REPLENISHMENT: "Reposição",
	},
	severity: {
		LOW: "Baixa",
		NORMAL: "Normal",
		CRITICAL: "Crítica",
	},
	form: {
		typeLabel: "Tipo",
		severityLabel: "Severidade",
		messageLabel: "Mensagem",
		messagePlaceholder: "Descreva a mensagem...",
	},
	messages: {
		created: "Mensagem criada com sucesso",
		resolved: "Mensagem resolvida",
		deleted: "Mensagem removida",
		createError: "Erro ao criar mensagem",
		deleteError: "Erro ao remover mensagem",
		loadError: "Erro ao carregar mensagens",
		resolveError: "Erro ao resolver mensagem",
	},
	resolvedBy: "Resolvida por {name} em {date}",
	createdBy: "Criada por {name}",
	dialogTitle: "Mensagens ativas",
	viewMessages: "Ver mensagens",
	view: "Ver",
	hiddenContent: "Conteúdo protegido — clique em revelar para ler",
	revealShort: "Revelar",
	hideShort: "Ocultar",
	showResolved: "Mostrar mensagens resolvidas",
	hideResolved: "Ocultar mensagens resolvidas",
	noResolvedMessages: "Nenhuma mensagem resolvida",
	privacyNote: "Ao fechar, todas as mensagens voltam a ficar ocultas.",
};
